module.exports = __webpack_public_path__ + "img/marine.430e5bc3.png";